import { useWindowSize } from '@hooks';
import ExpandIcon from '@icons/expand.svg?react';
import { Tooltip } from '@ui/tooltip';
import Styled from './ExpandButton.styled';

interface Props {
  className: string;
  testId: string;
  isActive: boolean;
  yPosition?: number;
  onClick: () => void;
}

function ExpandButton(props: Props) {
  const { className, testId, isActive, yPosition, onClick } = props;
  const windowSize = useWindowSize();

  return (
    <Styled.ExpandWrapper
      className={className}
      data-testid={testId}
      onClick={onClick}>
      <Styled.ExpandButton
        yPosition={yPosition}
        isActive={isActive}
        tabIndex={0}
        onClick={onClick}>
        {windowSize.isLarge ? (
          <Tooltip
            className="tooltip-wrapper"
            content={isActive ? null : 'Expand'}
            disableTouchListener={true}
            enterDelay={200}
            leaveDelay={0}
            placement="bottom-start">
            <ExpandIcon />
          </Tooltip>
        ) : (
          <ExpandIcon />
        )}
      </Styled.ExpandButton>
    </Styled.ExpandWrapper>
  );
}

export default ExpandButton;
